import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { TodoApi } from '../../api';
import Context from './index';

const TodoProvider = (props) => {
  const [allTodos, setAllTodo] = useState([]);

  const fetchTodo = async () => {
    try {
      await axios.get(`${TodoApi}`).then((resp) => {
        setAllTodo(resp.data);
      });
    } catch (error) {
      console.log('error', error);
    }
  };

  useEffect(() => {
    fetchTodo();
  }, [setAllTodo]);

  const addNewTodo = (tasks) => {
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
    const currentDate = new Date()
    const temp = {
      id: allTodos.length + 1,
      title: tasks,
      status: 'pending',
      badge: 'Pending',
      badgeclass: 'badge-light-danger',
      timelimit: currentDate.getDate() + " " + months[currentDate.getMonth()]
    };
    setAllTodo([temp, ...allTodos]);
  };

  const selectItem = (id, status, badgeClass) => {
    const temp = allTodos.reduce((todoAcc, item) => {
      if (item.id === id) {
        if (status === 'pending') {
          todoAcc.push({ ...item, status: status, badgeclass: badgeClass, badge: 'Pending' });
        } else if (status === 'completed') {
          todoAcc.push({ ...item, status: status, badgeclass: badgeClass, badge: 'Done' });
        }
      } else todoAcc.push(item);
      return todoAcc;
    }, []);

    setAllTodo(temp);
  };

  const markAllItems = (markAll) => {
    const updateStatus = allTodos.reduce((cartAcc, item) => {
      if (markAll === false) {
        cartAcc.push({ ...item, status: 'completed' });
      } else {
        cartAcc.push({ ...item, status: 'pending' });
      }
      return cartAcc;
    }, []);
    updateStatus.map((todo) => {
      return axios.put(`${TodoApi}/${todo.id}`, todo);
    });
    setAllTodo(updateStatus);
  };

  const removeItems = (id) => {
    setAllTodo(allTodos.filter((data) => data.id !== id));
  };

  return (
    <Context.Provider
      value={{
        ...props,
        allTodos,
        addNewTodo: addNewTodo,
        selectedItem: selectItem,
        markAllItems: markAllItems,
        removeItems: removeItems,
      }}
    >
      {props.children}
    </Context.Provider>
  );
};

export default TodoProvider;
